import { Grid, withStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import FileUploaderButton from '../../../Core/Controls/GenericFileUploader';
import { getJobRequireScheduledDocuments } from '../../../Core/Services/InternalUser/ControllerService/jobDetailsService';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper } from '@material-ui/core';

const StyledTableCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        fontWeight: 550,
        padding: '5px 10px'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover
        }
    }
}))(TableRow);

const RequiredDocumentsModal = (props) => {
    const [jobdocument, setJobDocument] = useState({
        list: [],
        refresherFlag: ''
    });
    useEffect(async () => {
        if (props.rowData.scheduleID) {
            let res = await getJobRequireScheduledDocuments(props.rowData.scheduleID);
            setJobDocument((jobdocument) => ({ ...jobdocument, list: res.data.list }));
        }
    }, [props.rowData.scheduleID, jobdocument.refresherFlag]);

    const dataReload = () => {
        setJobDocument((jobdocument) => ({ ...jobdocument, refresherFlag: new Date() }));
        props?.onFormSubmit && props?.onFormSubmit(true);
    };

    return (
        <TableContainer component={Paper} elevation={0}>
            <Table>
                <TableBody>
                    {jobdocument.list.length > 0 ? (
                        jobdocument.list.map((m, index) => (
                            <StyledTableRow key={m.scheduleDocID || index}>
                                <StyledTableCell sx={{ width: '70%', py: 1 }}>{m.docName}</StyledTableCell>

                                <StyledTableCell align="right" sx={{ py: 1 }}>
                                    <FileUploaderButton
                                        docName={m.docName}
                                        recordId={m.scheduleDocID}
                                        fileUploaderConfigName="ScheduleDocumentsRequired"
                                        fileCount={m.fileCount}
                                        gridRelaod={dataReload}
                                        docIDPassed={true}
                                    />
                                </StyledTableCell>
                            </StyledTableRow>
                        ))
                    ) : (
                        <StyledTableRow>
                            <TableCell colSpan={2} align="center">
                                No Required Documents Found...
                            </TableCell>
                        </StyledTableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default RequiredDocumentsModal;
